import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import React from 'react';
import { Typography, TableSortLabel as UiCoreTableSortLabel } from '@lumahealthhq/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @ignore - internal component.
 */
function TableSortLabel(_ref) {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const renderAsString = typeof children === 'string' || typeof children === 'number';
  return /*#__PURE__*/_jsx(UiCoreTableSortLabel, _extends({}, props, {
    children: renderAsString ? /*#__PURE__*/_jsx(Typography
    // TODO
    // variant="bW600F12"
    , {
      sx: ({
        palette: {
          text: {
            primary
          }
        }
      }) => ({
        color: primary,
        fontSize: '12px',
        fontWeight: 600
      }),
      children: children
    }) : children
  }));
}
export default TableSortLabel;